import { sortSpaces } from '@/lib/spaceOrder';
import { SpaceDao } from '@rock/db-admin';
import type { Space, SpaceId } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

const dao = new SpaceDao();

const allSpacesState = dao.spacesAtom('all');

/**
 * Every space, in the app's dashboard order (see `sortSpaces`). Sorted HERE rather than at each call
 * site so every admin surface that lists spaces — nav, pickers, tables, the dashboard — inherits the
 * same order without having to remember to ask for it. Firestore returns these in document-id order,
 * which is alphabetical and matches nothing the user sees in the app.
 */
export const spacesState = atom(async (get): Promise<Space[]> => sortSpaces(await get(allSpacesState)));

export const spaceState = atomFamily((spaceId: SpaceId) => dao.spaceAtom(spaceId), shallowEqual);
